import { DEFAULT_BRANDING } from 'src/config/constants.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

const StartHelp = () => import('src/views/Miscellaneous/Start/StartHelp.vue')
const StartHelpProblem = () => import('src/views/Miscellaneous/Start/StartHelpProblem.vue')
const SettingsCopyright = () => import('src/views/User/Settings/SettingsCopyright.vue')
const CypressSampleSchoolsMain = () => import('src/views/Development/Generation/CypressSampleSchoolsMain.vue')
const CypressSampleSchoolGeneration = () => import('src/views/Development/Generation/CypressSampleSchoolGeneration.vue')
const SampleSchoolDataSync = () => import('src/views/Development/Generation/SampleSchoolDataSync.vue')

const handleUntisRouteNavigation = (to) => {
  const { query } = to
  if (query.code || query.state || query.error || query.error_description || query.code_challenge) {
    const apiWebuntisRoute = GlobalPrototypes.router.resolve({
      name: 'api-webuntis',
      query: to.query
    }).href
    window.location.href = `${import.meta.env.VITE_IDM_URL}${apiWebuntisRoute}`
    return false
  }
  return { path: '/', query: { branding: 'UNTIS' } }
}

const routes = [
  {
    path: '/idp/api/auth/:uuid',
    name: 'idp',
    meta: {
      isPublic: true,
      middleware: null
    },
    beforeEnter: (to) => {
      const updatedPath = to.path.replace('/idp', '')
      const { query } = to
      window.location.href = `${import.meta.env.VITE_IDM_URL}${updatedPath}?client_id=${query.client_id}&redirect_uri=${query.redirect_uri}&state=${query.state}`
      return false
    }
  },
  {
    path: '/webuntis',
    name: 'webuntis',
    meta: {
      isPublic: true,
      isRouteHardRedirecting: true
    },
    beforeEnter: handleUntisRouteNavigation
  },
  {
    path: '/api/auth/return',
    name: 'api-webuntis',
    meta: {
      isPublic: true
    },
    beforeEnter: handleUntisRouteNavigation
  },
  {
    path: '/data-protection/:branding?',
    component: SettingsCopyright,
    meta: {
      isPublic: true
    },
    beforeEnter: (to) => {
      // branding already applied to query
      if (to.query.branding) return

      // apply branding from url param to query
      return { path: '/data-protection', query: { branding: to.params.branding || DEFAULT_BRANDING } }
    }
  },
  {
    path: '/help',
    component: StartHelp,
    name: 'login-start-help',
    meta: {
      isPublic: true,
      headerText: 'global.headers.help'
    }
  },

  {
    path: '/help/problem',
    component: StartHelpProblem,
    name: 'login-start-help-problem',
    meta: {
      isPublic: true,
      headerText: 'global.headers.help'
    }
  },
  import.meta.env.VITE_SAMPLE_SCHOOLS && {
    path: '/sample/build',
    component: CypressSampleSchoolsMain,
    name: 'cypress-sample-schools-generation-main',
    meta: {
      isPublic: true
    },
    children: [
      {
        path: 'sample-school',
        component: CypressSampleSchoolGeneration,
        name: 'cypress-sample-schools-generation'
      },
      {
        path: 'data-sync',
        component: SampleSchoolDataSync,
        name: 'sample-schools-data-sync'
      }
    ]
  }
].filter(el => el)

export default routes
